import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Toast, Loading } from 'modules/Core/Common';
import { Selectors, Async, Actions } from 'modules/Auth/AuthSlice';
import { LoginForm } from 'modules/Auth/Login/LoginForm';
import { TwoFactorModal } from 'modules/Auth/TwoFactor';
import { ZIndexes } from 'modules/Utils/ZIndexes';
import { withTheme } from 'styled-components';
import * as S from './TokenExpiredLogin.styles';
import i18n from 'i18next';

const TokenExpiredLogin = ({ theme }) => {
  const loading = useSelector(Selectors.selectLoading);
  const lastPageAccessed = useSelector(Selectors.getLastPageAccessed);
  const twoFactor = useSelector(Selectors.twoFactor);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.querySelector('html').style.overflow = 'hidden';

    return () => {
      document.querySelector('html').style.overflow = 'auto';
    };
  }, []);

  // Requests made behind the overlay were cancelled while the token was expired,
  // so re-entering the app always needs a redirect/reload — whether the user
  // finished on the password step or on the 2FA step.
  const handleReauthenticated = () => {
    // Redirect to the original page if stored, otherwise reload to go to dashboard
    if (lastPageAccessed && lastPageAccessed !== '/dashboard') {
      navigate(lastPageAccessed);
    } else {
      navigate(0);
    }
  };

  const handleSignIn = async (data) =>
    dispatch(
      Async.signIn(
        data,
        (e) => {
          Toast(e.message, 'error');
        },
        handleReauthenticated
      )
    );

  return (
    <S.Container>
      <S.FormContainer>
        <S.Title>{i18n.t('commons.buttons.sign-in-button')}</S.Title>
        <S.Description>
          {i18n.t('login.continue-using')}
          {` ${theme.name}`}
        </S.Description>
        {loading && !twoFactor ? (
          <div>
            <Loading position="relative" />
          </div>
        ) : (
          <LoginForm onSubmit={handleSignIn} theme={theme} />
        )}
      </S.FormContainer>
      <TwoFactorModal
        isOpen={!!twoFactor}
        onClose={() => dispatch(Actions.clearTwoFactor())}
        onSuccess={handleReauthenticated}
        zIndex={ZIndexes.tokenExpiredModal}
      />
    </S.Container>
  );
};

TokenExpiredLogin.propTypes = {
  theme: PropTypes.object,
};

export default withTheme(TokenExpiredLogin);
